/*
 * Created on Fri Jul 9 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 * Note: !! video can't be viewed in development. Uncomment iframe tag to view 
 */

import { useState, useEffect, useRef, useReducer } from 'react';
import { Navigation } from '../Header';
import { Carousel } from 'react-bootstrap';
import { images, mobileImages } from '../constants';
import ReactPlayer from "react-player/vimeo"
import { IoIosArrowForward } from "react-icons/io";
import { PlayButton } from '../components';
import { useWindowDimensions, usePrevState } from '../utils/helpers';
import parse from 'html-react-parser';
import 'animate.css';
import useAuth from 'hooks/auth.hook';

let links = ['576658110', '576674684', '576675937'];
let youtubeLinks = ['ZQ0x0sy-J3k', '_CXIk98CkK0', 'RWzK7zEyL_4'];
let gifTitles = ['<span class="fashion20">fashion 2.0</span>', "i'm not fashion's perfect identity", 'fashion needs<br/> a makeover'];
// generate a random index number from links array
let randomLink = Math.floor(Math.random() * links.length);
// render a vimeo url from random number
let renderedUrl = `https://player.vimeo.com/video/${links[randomLink]}?autoplay=1&muted=1&loop=1&title=0&byline=0&badge=0&portrait=0`;
let renderedYoutubeUrl = `https://www.youtube.com/watch?v=${youtubeLinks[randomLink]}`;
let texts = [
    {
        title: 'the <br />itch',
        text: `to express our <br />
        version of fashion is contagious. We’re not designed to fit one prescribed trend every season, just as no one school of thought <br />
        is subscribed by every human. <br />
        We’re our own eclectic ideas, driven instinctively by curiosity <br />
        and erratic impulses—the onliest sentiment needed to reflect <br />
        the code of fashion. <br />
        <br />
        We’re not fashion’s perfect identity. We’re the next change of seasons.`,
        text2: `to express <br />
        our version of fashion is <br />
        contagious. We’re not <br />
        designed to fit one <br />
        prescribed trend every <br />
        season, just as no one <br />
        school of thought is
        subscribed by every human. <br />
        We’re our own eclectic <br />
        ideas, driven instinctively <br />
        by curiosity and erratic <br />
        impulses—the onliest <br />
        sentiment needed to reflect <br />
        the code of fashion. <br />
        <br />
        We’re not fashion’s <br />
        perfect identity. We’re the <br />
        next change of seasons.`
    },
    {
        title: 'to decentralise',
        text: `may well be the only way <br />
        to revive the spirit and enthusiasm for fashion. And it starts with having <br />
        a media that must involve the contribution of every fashion profession <br />
        and enthusiast. A solution that removes corporate and creative biases, <br />
        an egalitarian ecosystem which celebrates equal opportunity and <br />
        designed for ideas to come.`,
        text2: `may well be the only way to revive <br />
        the spirit and enthusiasm for fashion. <br />
        And it starts with having a media <br />
        that must involve the contribution <br />
        of every fashion profession and <br />
        enthusiast. A solution that removes <br />
        corporate and creative biases, <br />
        an egalitarian ecosystem which <br />
        celebrates equal opportunity <br />
        and designed for ideas to come.`
    },
    {
        title: 'fashion',
        text: `is art performed <br/>
        with the human body. There’s no <br />
        right or wrong, like you don’t <br />
        really pass or fail art. So here’s to <br />
        a new trend. To the art of <br />
        individuality—fashion governed <br />
        collectively. To a level playing field <br />
        than opinions set by the elite few. <br />
        And to becoming one, as diverse <br />
        intelligentsias while we move <br />
        towards a more inclusive, <br />
        inspiring and transparent future. <br />
        <br />
        Here’s to fashion 2.0.`,
        text2: `is art performed <br/>
        with the human body. There’s no <br />
        right or wrong, like you don’t <br />
        really pass or fail art. So here’s to <br />
        a new trend. To the art of <br />
        individuality—fashion governed <br />
        collectively. To a level playing field <br />
        than opinions set by the elite few. <br />
        And to becoming one, as diverse <br />
        intelligentsias while we move <br />
        towards a more inclusive, <br />
        inspiring and transparent future. <br />
        <br />
        Here’s to fashion 2.0.`
    },
    {
        title: 'with you',
        text: `as creative partners can we fashion a new zeitgeist.<br />
        Because culture is ultimately created by us—a reflection of our <br />
        creativity, or the lack thereof. So let’s come together, as different <br />
        creative minds with the same passion. Let’s rediscover <br />
        camaraderie and restore the lost attitude of self-expression. <br />
        After all, who’re the ones sustaining the fashion landscape? <br />
        Isn’t it you—the fashion artists, lovers and companies? <br />
        <br />
        Welcome to your decentralised fashion channel.`,
        text2: `as creative partners <br />
        can we fashion a new zeitgeist.<br />
        Because culture is ultimately <br />
        created by us—a reflection of <br />
        our creativity, or the lack thereof. <br />
        So let’s come together, as <br />
        different creative minds with the <br />
        same passion. Let’s rediscover <br />
        camaraderie and restore the lost <br />
        attitude of self-expression. After <br />
        all, who’re the ones sustaining <br />
        the fashion landscape? Isn’t it <br />
        you—the fashion artists, lovers <br />
        and companies? <br />
        <br />
        Welcome to your decentralised <br />
        fashion channel.`
    }
]
export default function Manifesto() {
    const { session } = useAuth()
    const [index, setIndex] = useState(0);
    const [touchX, setTouchX] = useState(0);
    const [touchY, setTouchY] = useState(0);
    const [hoveredIndex, setHoveredIndex] = useState(-1);
    const [opacity, setOpacity] = useState(1);
    const [slideToPrev, setSlideToPrev] = useState(false);
    // generate random gif
    let gif = 'm-gif-' + (randomLink + 1) + '.gif';
    // add mouseover event listener to carousel indicators
    
    const [mute, toggleMute] = useReducer(
        mute => !mute,
        false
    );

    const carouselRef = useRef();

    const { windowWidth } = useWindowDimensions();
    const prevIndex = usePrevState(index);

    const handleSelect = (selectedIndex, e) => {
        console.log('carousel select', selectedIndex);
        setIndex(selectedIndex);
        selectedIndex > index ? setSlideToPrev(false) : setSlideToPrev(true);
    }
    const handleWheel = (swipe) => {
        setTimeout(() => {
            if (swipe > 0) {
                setSlideToPrev(false);
                if (index !== 4) carouselRef.current.next()
            }
            else {
                setSlideToPrev(true);
                if (index !== 0) carouselRef.current.prev()
            }
        }, 250);
    };
    const handleTouch = e => {
        let lastTouch = e.changedTouches[0];
        let xDiff = touchX - lastTouch.clientX;
        let yDiff = touchY - lastTouch.clientY;
        handleWheel(Math.abs(xDiff) > Math.abs(yDiff) ? xDiff : yDiff);
    };

    const slideInLeft = (i) => i <= prevIndex && i === index && slideToPrev ? 'prev-item' : '';

    useEffect(() => {
        setHoveredIndex(index - 1);
        document.getElementsByClassName('carousel-indicators')[0].setAttribute('active', index - 1);
        setTimeout(() => {
            index === 0 ? setOpacity(1) : setOpacity(0)
        }, 300);
    }, [index])

    useEffect(() => {
        let indicators = document.querySelectorAll(".carousel-indicators li");
    
        indicators.forEach((el, i) => el.addEventListener('mouseover', () => {
            setHoveredIndex(i - 1);
            document.getElementsByClassName('carousel-indicators')[0].setAttribute('active', i - 1);
        }));
        indicators.forEach((el, i) => el.addEventListener('mouseout', () => {
            setHoveredIndex(index - 1);
            document.getElementsByClassName('carousel-indicators')[0].setAttribute('active', index - 1);
        }));
    }, [])

    return (
        <>
            {windowWidth >= 1030 ? <div className="nav-label manifesto">{hoveredIndex >= 0 ? texts[hoveredIndex].title : null}</div> : null}
            <ScrollText goNext={() => carouselRef.current.next()} opacity={opacity} />
            <Carousel
                ref={carouselRef}
                id="tourSlide"
                className={"manifesto " + (session ? "logged-in" : "")}
                activeIndex={index}
                onSelect={handleSelect}
                onWheel={(e) => handleWheel(e.deltaY > 0)}
                onTouchStart={(e) => {
                    setTouchX(e.touches[0].clientX);
                    setTouchY(e.touches[0].clientY)
                }}
                onTouchMove={handleTouch}
                interval={null}
                touch={false}
                nextIcon=""
                prevIcon=""
            >
                <Carousel.Item id="mItem0">
                    {windowWidth >= 1030 ?
                        <>
                            <div className="react-player-div">
                                {/* <iframe
                                    className='react-player'
                                    src={renderedUrl}
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    allowFullScreen
                                    title="fashion video"
                                ></iframe> */}

                                {/* --------- !! NOTE: video can't be viewed in development. Uncomment iframe tag above to view --------- */}
                                <ReactPlayer
                                    className='react-player'
                                    url={renderedUrl}
                                    playing={true}
                                    loop={true}
                                    volume={mute ? 1 : 0}
                                    muted={true}
                                    width="100%"
                                    height="56.25vw"
                                />
                            </div>
                            <div className={"mute-toggle " + (mute ? "music-off" : "music-on")} onClick={toggleMute}></div>
                        </>
                        :
                        <>
                            <img src={mobileImages[gif]} alt="" />
                            <div className="gif-description middle-xy" style={{ top: randomLink === 0 ? '60%' : '61.5%' }}>
                                <p>{parse(gifTitles[randomLink])}</p>
                                <figure>
                                    <PlayButton link={renderedYoutubeUrl}/>
                                    <div className="play-description">
                                        <span>WATCH</span><br />
                                        <span>I'M FASHION 2.0</span>
                                    </div>
                                </figure>
                            </div>
                        </>
                    }
                </Carousel.Item>
                <Carousel.Item id="mItem1" className={slideInLeft(1)}>
                    <TextDiv index={1} />
                    <ImgDiv index={1} />
                </Carousel.Item>
                <Carousel.Item id="mItem2" className={slideInLeft(2)}>
                    <TextDiv index={2} />
                    <ImgDiv index={2} />
                </Carousel.Item>
                <Carousel.Item id="mItem3" className={slideInLeft(3)}>
                    <TextDiv index={3} />
                    <ImgDiv index={3} />
                </Carousel.Item>
                <Carousel.Item id="mItem4">
                    <TextDiv index={4} />
                    <ImgDiv index={4} />
                </Carousel.Item>
            </Carousel>
        </>
    )
}

export function ScrollText({ goNext, opacity, addClass }) {
    return (
        <div className={"scroll-text pn-bold " + (addClass ? addClass : '')} onClick={goNext} style={{ opacity: opacity, pointerEvents: opacity === 0 ? 'none' : null }}>
            <span>SCROLL</span>
            <IoIosArrowForward />
        </div>
    )
}

function TextDiv({ index }) {
    const { windowWidth } = useWindowDimensions();
    return (
        <div className="m-text-div middle-xy">
            <div className="title">{parse(texts[index - 1].title)}</div>
            <div className="text text-left">{parse(windowWidth >= 1030 ? texts[index - 1].text : texts[index - 1].text2)}</div>
        </div>
    )
}

function ImgDiv({ index }) {
    const { windowWidth } = useWindowDimensions();
    let img = 'm-slide-' + index + '.png';
    return (
        <div className="m-img-div">
            <img className="middle-x" src={windowWidth >= 1030 ? images[img] : mobileImages[img]} alt="" />
        </div>
    )
}